<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure" role="doc-chapter">
<div class="epigraph" role="doc-epigraph">
<p class="epf"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>Myths often do a lot of theoretical good, while they are still new.</p>
<p class="ept">Gilbert Ryle, <i>The Concept of Mind</i></p>
</div>
<div class="epigraph" role="doc-epigraph">
<p class="epf">A whole volume could well be written on the myths of modern man, on the mythologies camouflaged in the plays that he enjoys, in the books that he reads. The cinema, that “dream factory,” takes over and employs countless mythical motifs.</p>
<p class="ept">Mircea Eliade, <i>The Sacred and the Profane</i></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-ball-0005.vue?13170032